import React, { useEffect, useMemo, useState } from 'react';
import { Upload, Button, Typography, Card, Row, Col, Divider, notification, Spin, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileCode, faLink } from '@fortawesome/free-solid-svg-icons';
import LinkEstoque from './LinkEstoque';
import RelacaoProdutos from './ProdutoLinkado';
import CadastroProdutoModal from './CadastroProdutoModal';

const { Title, Text } = Typography;
const XmlToJsonConverter = ({ setPodeAbandonar }) => {
  const [produtos, setProdutos] = useState([]);
  const [cabecalho, setCabecalho] = useState(null);
  const [destinatario, setDestinatario] = useState(null);
  const [loading, setLoading] = useState(false);
  const [desabilitarFinalizar, setDesabilitarFinalizar] = useState(false);
  const [transactionId, setTransactionId] = useState('');
  const [executarBusca, setExecutarBusca] = useState(false);
  const accessToken = window.localStorage.getItem("accessToken");
  const idUser = window.localStorage.getItem("idUser");
  const [loja, setLoja] = useState({});
  const [selectedProduto, setSelectedProduto] = useState(null);

  const [isModalVisibleItem, setModalVisibleItem] = useState(false);
  const [isFinalizarEntrada, setIsFinalizarEntrada] = useState(false);

  const [processamentoMsg, setProcessamentoMsg] = useState('');
  const [categoria, setCategoria] = useState(null);

  const [impostoNotaSimples, setImpostoNotaSimples] = useState(null);

  const [categorias, setCategorias] = useState([]);

  const [produtosParaCriar, setProdutosParaCriar] = useState([]);



  const produtosOrdenados = useMemo(() => {
    const semEncontrado = produtos
      .filter(p => !p.encontradoVia)
      .sort((a, b) => Number(a.nItem) - Number(b.nItem));

    const comEncontrado = produtos
      .filter(p => p.encontradoVia)
      .sort((a, b) => Number(a.nItem) - Number(b.nItem));

    return [...semEncontrado, ...comEncontrado];
  }, [produtos]);

  useEffect(() => {
    if (accessToken && idUser) {
      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + accessToken,
        },
      };

      axios
        .get(
          `https://techfood-api.herokuapp.com/v1/restaurantes/usuario/${idUser}`,
          options,
        )
        .then(restaurante => {
          setLoja(restaurante.data);
          console.log(restaurante.data);
        });
    }
  }, [idUser, accessToken]);

  useEffect(() => {
    if (loja.id) {
      const buscarCategoria = async () => {
        const options = {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + accessToken,
          },
        };

        try {
          const resp = await axios.get(
            `https://techfood-api.herokuapp.com/v1/categorias/restaurante/${loja.id}`,
            options
          );

          if (resp.data.length > 0) {
            setCategoria(resp.data[0]);
            setCategorias(resp.data);
          }
        } catch (error) {
          console.error('Erro ao buscar categorias:', error);
        }
      };

      buscarCategoria();
    }
  }, [loja?.id]);


  useEffect(() => {
    async function fetchData() {
      console.log('dentro do fetchData');
      try {
        var cont = 0;
        while (cont < 6) {
          await new Promise((resolve) => setTimeout(resolve, 10000));
          const options = {
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + accessToken,
            },
          };

          console.log('getTransacaoById');
          const { data: result } = await axios.get(`https://techspdv-api-d3e739785e34.herokuapp.com/v1/movimentacaoEstoque/transacao/${transactionId}`, options);


          console.log(result);
          //setTransactionId(result);

          if (result.status === '2') {
            notification.info({
              message: 'Informação',
              description: 'As alterações estão sendo processadas.',
            });
          }
          if (result.status === '3') {
            setExecutarBusca(false);
            //handleRefreshClick();
            notification.success({
              message: 'Sucesso',
              description: 'As alterações foram concluidas.',
            });

            cont = 7;
            break;
          }
          cont++;
        }

        if (cont === 6) {
          window.alert('O Processamento ainda esta ocorrendo!');
        }
      } catch (error) {
        console.error(error);
      }
    }

    if (loja.id && transactionId && executarBusca) {
      fetchData();
    }
  }, [loja.id, transactionId, executarBusca]);

  const validarProdutos = async (produtosExtraidos, cnpjEmit) => {

    if (produtosExtraidos) {
      console.log(produtosExtraidos);

      try {
        console.log('produtosExtraidos:', produtosExtraidos);
        console.log('Tamanho do array:', produtosExtraidos.length);

        for (let i = 0; i < produtosExtraidos.length; i++) {
          console.log(`Item ${i}`, produtosExtraidos[i]);

          const options = {
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + accessToken,
            },
          };

          console.log(loja);
          console.log(produtosExtraidos[i].cProd);
          console.log(cnpjEmit);
          produtosExtraidos[i].cnpj = cnpjEmit;
          let isEmbalagem = false;

          if (produtosExtraidos[i].ean !== 'SEM GTIN' && produtosExtraidos[i].ean !== '' && produtosExtraidos[i].ean !== null) {
            let responseEan = await axios.get(
              `https://techspdv-api-d3e739785e34.herokuapp.com/v1/restaurantes/${loja.id}/produtos/buscarporean/${produtosExtraidos[i].ean}`,
              options
            );
            console.log(responseEan.data);
            if (!responseEan.data) {
              responseEan = await axios.get(
                `https://techspdv-api-d3e739785e34.herokuapp.com/v1/${loja.id}/embalagens/barras/${produtosExtraidos[i].ean}`,
                options
              );

              if(responseEan.data.length > 0){
                isEmbalagem = true;
                responseEan.data = responseEan.data[0];
              }
            }

            if (responseEan.data) {
              produtosExtraidos[i].id = responseEan.data.id;
              produtosExtraidos[i].encontradoVia = 'EAN';
              produtosExtraidos[i].custo = produtosExtraidos[i].custo;
              produtosExtraidos[i].codigoDeIntegracao = produtosExtraidos[i].codigo;
              produtosExtraidos[i].nomeSistema = produtosExtraidos[i].nome;

              console.log('Adicionando informações ao produto');
            } else {
              const response = await axios.get(
                `https://techspdv-api-d3e739785e34.herokuapp.com/v1/referencias-entrada/por-cnpj/${cnpjEmit}/${loja.id}/${produtosExtraidos[i].cProd}`,
                options
              );

              if (response.data.length > 0) {
                produtosExtraidos[i].id = response.data[0].idProd;
                produtosExtraidos[i].encontradoVia = 'CPROD';
                produtosExtraidos[i].custo = produtosExtraidos[i].custo;
                produtosExtraidos[i].codigoDeIntegracao = produtosExtraidos[i].codigo;
                produtosExtraidos[i].nomeSistema = produtosExtraidos[i].nome;


                console.log('Adicionando informações ao produto');
              }

              console.log('Resposta para item:', produtosExtraidos[i], response.data);
            }
          } else {

            const response = await axios.get(
              `https://techspdv-api-d3e739785e34.herokuapp.com/v1/referencias-entrada/por-cnpj/${cnpjEmit}/${loja.id}/${produtosExtraidos[i].cProd}`,
              options
            );

            if (response.data.length > 0) {
              produtosExtraidos[i].id = response.data[0].idProd;
              produtosExtraidos[i].encontradoVia = 'CPROD';
              produtosExtraidos[i].custo = produtosExtraidos[i].custo;
              produtosExtraidos[i].codigoDeIntegracao = produtosExtraidos[i].codigo;
              produtosExtraidos[i].nomeSistema = produtosExtraidos[i].nome;

              console.log('Adicionando informações ao produto');
            }

            console.log('Resposta para item:', produtosExtraidos[i], response.data);
          }

        }
        console.log(produtosExtraidos);
        return produtosExtraidos;
      } catch (error) {
        console.error(`Erro ao buscar dados do item`, error);
        return produtosExtraidos;
      }
    } else {
      return produtosExtraidos;
    }
  };




  const openModalItem = produto => {
    console.log(produto);
    setSelectedProduto(produto);
    setModalVisibleItem(!isModalVisibleItem);
  };

  const handleVoltarClick = () => {
    setModalVisibleItem(false);
  };




  const xmlToJson = (xml) => {
    const obj = {};
    if (xml.nodeType === 1 && xml.attributes.length > 0) {
      obj['@attributes'] = {};
      for (let j = 0; j < xml.attributes.length; j++) {
        const attribute = xml.attributes.item(j);
        obj['@attributes'][attribute.nodeName] = attribute.nodeValue;
      }
    } else if (xml.nodeType === 3) {
      return xml.nodeValue.trim();
    }

    if (xml.hasChildNodes()) {
      for (let i = 0; i < xml.childNodes.length; i++) {
        const item = xml.childNodes.item(i);
        const nodeName = item.nodeName;
        const nodeValue = xmlToJson(item);
        if (typeof nodeValue === 'string' && nodeValue === '') continue;

        if (obj[nodeName] === undefined) {
          obj[nodeName] = nodeValue;
        } else {
          if (!Array.isArray(obj[nodeName])) {
            obj[nodeName] = [obj[nodeName]];
          }
          obj[nodeName].push(nodeValue);
        }
      }
    }
    return obj;
  };

  const getText = (val) => {
    if (typeof val === 'object' && val !== null && '#text' in val) return val['#text'];
    return val || '';
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return isNaN(date) ? dateStr : date.toLocaleDateString('pt-BR');
  };

  const formatCurrency = (value) => {
    const num = Number(value);
    return isNaN(num) ? value : num.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  };

  const formatCNPJ = (cnpj) => {
    if (!cnpj) return '';
    return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
  };

  const formatIE = (ie) => {
    if (!ie) return '';
    return ie.replace(/(\d{3})(\d{3})(\d{3})(\d{3})?/, (match, p1, p2, p3, p4) =>
      p4 ? `${p1}.${p2}.${p3}.${p4}` : `${p1}.${p2}.${p3}`
    );
  };

  const extractImpostoDetalhado = (imposto) => {
    // ---- ICMS ----
    const icmsNode = imposto?.ICMS || {};
    const icmsKey = Object.keys(icmsNode)[0];
    const icms = icmsKey ? icmsNode[icmsKey] : {};

    // ---- IPI ----
    const ipiNode = imposto?.IPI || {};
    const ipiKey = Object.keys(ipiNode)[0]; // IPITrib | IPINT
    const ipi = ipiKey ? ipiNode[ipiKey] : {};

    // ---- PIS ----
    const pisNode = imposto?.PIS || {};
    const pisKey = Object.keys(pisNode)[0]; // PISAliq | PISOutr | PISNT | PISQtde
    const pis = pisKey ? pisNode[pisKey] : {};

    // ---- COFINS ----
    const cofinsNode = imposto?.COFINS || {};
    const cofinsKey = Object.keys(cofinsNode)[0]; // COFINSAliq | COFINSOutr | COFINSNT | COFINSQtde
    const cofins = cofinsKey ? cofinsNode[cofinsKey] : {};

    const out = {
      // ICMS
      origem: getText(icms?.orig),
      cst: getText(icms?.CST) || 0,
      csosn: getText(icms?.CSOSN) || 0,
      pICMS: getText(icms?.pICMS) || 0,
      vICMS: getText(icms?.vICMS) || 0,
      vBC: getText(icms?.vBC) || 0,

      // IPI
      cstIPI: getText(ipi?.CST) || '',
      pIPI: 0,
      vIPI: 0,

      // PIS
      cstPIS: getText(pis?.CST) || '',
      vBCPIS: 0,
      pPIS: 0,
      qBCProdPIS: 0,    // base por quantidade (quando houver)
      vAliqProdPIS: 0,  // alíquota em R$/un (quando houver)
      vPIS: 0,

      // COFINS
      cstCOFINS: getText(cofins?.CST) || '',
      vBCCOFINS: 0,
      pCOFINS: 0,
      qBCProdCOFINS: 0,    // base por quantidade (quando houver)
      vAliqProdCOFINS: 0,  // alíquota em R$/un (quando houver)
      vCOFINS: 0,
    };

    // ---- IPI: IPITrib / IPINT ----
    if (ipiKey === 'IPITrib') {
      out.pIPI = getText(ipi?.pIPI) || 0;
      out.vIPI = getText(ipi?.vIPI) || 0;
      // vBC também pode existir
      if (getText(ipi?.vBC)) out.vBCIPI = getText(ipi?.vBC);
    } else if (ipiKey === 'IPINT') {
      // sem valores, apenas CST (já atribuído acima)
    }

    // ---- PIS: PISAliq / PISOutr / PISNT / PISQtde ----
    if (pisKey === 'PISAliq') {
      out.vBCPIS = getText(pis?.vBC) || 0;
      out.pPIS = getText(pis?.pPIS) || 0;
      out.vPIS = getText(pis?.vPIS) || 0;
    } else if (pisKey === 'PISOutr') {
      // Pode vir base/percentual OU quantidade/aliquota por un.
      if (getText(pis?.vBC)) out.vBCPIS = getText(pis?.vBC);
      if (getText(pis?.pPIS)) out.pPIS = getText(pis?.pPIS);
      if (getText(pis?.qBCProd)) out.qBCProdPIS = getText(pis?.qBCProd);
      if (getText(pis?.vAliqProd)) out.vAliqProdPIS = getText(pis?.vAliqProd);
      if (getText(pis?.vPIS)) out.vPIS = getText(pis?.vPIS);
      // Se não vier vPIS mas vier qBCProd * vAliqProd, você pode calcular se quiser.
    } else if (pisKey === 'PISQtde') {
      out.qBCProdPIS = getText(pis?.qBCProd) || 0;
      out.vAliqProdPIS = getText(pis?.vAliqProd) || 0;
      out.vPIS = getText(pis?.vPIS) || 0;
    } else if (pisKey === 'PISNT') {
      // Apenas CST
    }

    // ---- COFINS: COFINSAliq / COFINSOutr / COFINSNT / COFINSQtde ----
    if (cofinsKey === 'COFINSAliq') {
      out.vBCCOFINS = getText(cofins?.vBC) || 0;
      out.pCOFINS = getText(cofins?.pCOFINS) || 0;
      out.vCOFINS = getText(cofins?.vCOFINS) || 0;
    } else if (cofinsKey === 'COFINSOutr') {
      if (getText(cofins?.vBC)) out.vBCCOFINS = getText(cofins?.vBC);
      if (getText(cofins?.pCOFINS)) out.pCOFINS = getText(cofins?.pCOFINS);
      if (getText(cofins?.qBCProd)) out.qBCProdCOFINS = getText(cofins?.qBCProd);
      if (getText(cofins?.vAliqProd)) out.vAliqProdCOFINS = getText(cofins?.vAliqProd);
      if (getText(cofins?.vCOFINS)) out.vCOFINS = getText(cofins?.vCOFINS);
    } else if (cofinsKey === 'COFINSQtde') {
      out.qBCProdCOFINS = getText(cofins?.qBCProd) || 0;
      out.vAliqProdCOFINS = getText(cofins?.vAliqProd) || 0;
      out.vCOFINS = getText(cofins?.vCOFINS) || 0;
    } else if (cofinsKey === 'COFINSNT') {
      // Apenas CST
    }

    return out;
  };

  const converterImposto = (paraSimples, cstAtual) => {
    // Normaliza qualquer CST para a dezena-base
    function baseDezena(cst) {
      const n = parseInt(String(cst), 10);
      if (Number.isNaN(n)) return String(cst);
      if (n === 41) return '40';
      if (n >= 90) return '90';
      return String(Math.floor(n / 10) * 10).padStart(2, '0');
    }

    // Normal → Simples
    const mapNormalSimples = {
      '00': '102',
      '10': '102',
      '20': '102',
      '30': '102',
      '40': '400',
      '50': '500',
      '60': '500',
      '70': '900',
      '90': '900',
    };

    // Simples → Normal
    const mapSimplesNormal = {
      '101': '00',
      '102': '00',
      '103': '40',
      '201': '20',
      '202': '20',
      '203': '20',
      '300': '40',
      '400': '40',
      '500': '60',
      '900': '90',
    };

    if (paraSimples) {
      // Normal → Simples
      const dez = baseDezena(cstAtual);
      return mapNormalSimples[dez] || '900';
    } else {
      // Simples → Normal
      const dez = mapSimplesNormal[cstAtual] || '90';
      return baseDezena(dez);
    }
  };



  const sleep = (ms) => new Promise(res => setTimeout(res, ms));
  const handleFileUpload = async (file) => {
    setLoading(true);
    setProcessamentoMsg('Processando produtos do xml...');

    //     await sleep(5000);
    const reader = new FileReader();
    const produtosExtraidos = [];
    reader.onload = async (e) => {
      try {
        const xmlText = e.target.result;
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(xmlText, 'text/xml');
        const json = xmlToJson(xmlDoc);

        const nfeNode = json.nfeProc?.NFe || json.NFe;     // ✅ aceita nfeProc e NFe puro
        const infNFe = nfeNode?.infNFe;
        if (!infNFe) throw new Error('XML não parece conter <infNFe>.');

        const ide = infNFe?.ide || {};
        const emit = infNFe?.emit || {};
        const dest = infNFe?.dest || {};
        const total = infNFe?.total?.ICMSTot || {};
        const detArray = infNFe?.det;
        setImpostoNotaSimples(getText(emit?.CRT) == '1' || getText(emit?.CRT) == '4');


        if (Array.isArray(detArray)) {
          detArray.forEach((item) => {
            const prod = item.prod;
            const imposto = item.imposto;
            const impDet = extractImpostoDetalhado(imposto);
            produtosExtraidos.push({
              nItem: item?.['@attributes']?.nItem ?? null,
              nome: getText(prod?.xProd),
              ncm: getText(prod?.NCM),
              cfop: getText(prod?.CFOP),
              quantidade: getText(prod?.qCom),
              preco: (getText(prod?.vProd) / getText(prod?.qCom)),
              custo: (getText(prod?.vProd) - (prod?.vDesc ? getText(prod?.vDesc) : 0)) / getText(prod?.qCom),
              vProd: getText(prod?.vProd),
              ean: getText(prod?.cEAN),
              cProd: getText(prod?.cProd),
              uCom: getText(prod?.uCom),
              vDesc: prod.vDesc ? getText(prod?.vDesc) : '0',
              ...impDet,
            });
          });
        } else if (detArray?.prod) {


          console.log(loja.crt);
          const prod = detArray.prod;
          const imposto = detArray.imposto;
          const impDet = extractImpostoDetalhado(imposto);
          produtosExtraidos.push({
            nItem: detArray?.['@attributes']?.nItem ?? null,
            nome: getText(prod?.xProd),
            ncm: getText(prod?.NCM),
            cfop: getText(prod?.CFOP),
            quantidade: getText(prod?.qCom),
            preco: (getText(prod?.vProd) / getText(prod?.qCom)),
            custo: (getText(prod?.vProd) - (prod?.vDesc ? getText(prod?.vDesc) : 0)) / getText(prod?.qCom),
            vProd: getText(prod?.vProd),
            ean: getText(prod?.cEAN),
            cProd: getText(prod?.cProd),
            uCom: getText(prod?.uCom),
            vDesc: prod.vDesc ? getText(prod?.vDesc) : '0',
            ...impDet,
          });
        }

        setCabecalho({
          data: formatDate(getText(ide?.dhEmi)?.substring(0, 10) || getText(ide?.dEmi)),
          cnpj: getText(emit?.CNPJ),
          ie: getText(emit?.IE),
          uf: getText(emit?.enderEmit?.UF),
          nomeEmitente: getText(emit?.xNome),
          numero: getText(ide?.nNF),
          serie: getText(ide?.serie),
          chave: infNFe?.['@attributes']?.Id?.replace(/^NFe/, ''),
          total: formatCurrency(getText(total?.vNF)),
          qtdItens: produtosExtraidos.length,
        });

        setDestinatario({
          nome: getText(dest?.xNome),
          cnpj: getText(dest?.CNPJ),
        });

        const produtosValidados = await validarProdutos(produtosExtraidos, getText(emit?.CNPJ));
        console.log(produtosValidados);
        setProdutos(produtosValidados);

      } catch (error) {
        console.error('Erro ao processar XML:', error);
        setLoading(false);
        setProdutos([]);
        setCabecalho(null);
        setDestinatario(null);
      } finally {
        setLoading(false);
      }
    };

    reader.readAsText(file);

    return false;
  };

  const atualizarProdutosPorCProd = (produtos, produtosParaCriar) => {
    return produtos.map((produto) => {
      const atualizado = produtosParaCriar.find(
        (p) => String(p.cProd) === String(produto.cProd)
      );
      return atualizado ? atualizado : produto;
    });
  };


  const prepararEntrada = async () => {

    //setPodeAbandonar(false);
    setLoading(true);
    setProcessamentoMsg('Processando os produtos que não foram encontrados no sistema...');

    // 1. Criar produtos ainda não encontrados

    const produtosParaCriarAux = produtos
      .filter(p => !p.encontradoVia)
      .map(p => ({
        ...p,
        preco: '0',
        categoria: categoria ? categoria.id : ''
      }));


    if (produtosParaCriarAux.length > 0) {
      setProdutosParaCriar(produtosParaCriarAux);
      setIsFinalizarEntrada(true);
    } else {
      salvarEntrada([]);
    }
  };

  const salvarEntrada = async (produtosTratados) => {
    console.log(produtosTratados);

    setLoading(true);
    setPodeAbandonar(false);
    const options = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + accessToken,
      },
    };

    const vendaInterestadual = cabecalho.uf != loja.endereco.cidade.estado;
    console.log(vendaInterestadual);
    console.log(cabecalho.uf);
    console.log(loja.endereco.cidade.estado);



    let cfopInterestadual = [];
    if (vendaInterestadual) {
      try {
        cfopInterestadual = await axios.get(
          `https://techfood-api.herokuapp.com/v1/cfop-interestadual`,
          options,
        );
        console.log(cfopInterestadual.data);
      } catch (error) {
        console.error("Erro ao buscar CFOP:", error);
      }
    }

    for (const produto of produtosTratados) {

      console.log(produto);
      console.log(produto.vProd);
      console.log(produto.quantidade);
      setProcessamentoMsg('Cadastrando e vinculando produtos por código de referência (cProd) ou (EAN)...');

      try {
        const numOrNull = (v) => {
          const n = Number(v);
          return Number.isFinite(n) ? n : null;
        };




        let converterImpostos = false;
        const impostoLojaSimples = (loja.crt == '1' || loja.crt == '4');

        if (impostoNotaSimples == impostoLojaSimples) {
          converterImpostos = false;
        } else {
          converterImpostos = true;
        }

        let cst = '';

        if (converterImpostos) {
          cst = converterImposto(impostoLojaSimples, produto.csosn || produto.cst);
        } else if (produto.csosn) {
          cst = produto.csosn;
        } else if (produto.cst) {
          cst = produto.cst;
        }


        const trocarCfop = (cfop, cfopInterestadual) => {
          console.log('trocar cfop');

          const novoCfop = cfopInterestadual.find(p => p.externo === cfop);
          console.log(novoCfop);
          console.log(cfopInterestadual);
          console.log(cfop);
          return novoCfop.interno || cfop;
        };



        const payload = {
          nome: produto.nome,
          descricao: produto.nome,
          ean: produto.ean || 'SEM GTIN',
          ncm: produto.ncm || '',
          cfop: vendaInterestadual ? trocarCfop(produto.cfop, cfopInterestadual.data) : produto.cfop,
          preco: produto.preco || 0,
          custo: produto.custo || 0,
          unidade: produto.uCom || 'UN',
          codigo: null,
          ntipoItem: produto.nTipoItem || '0',
          cst: cst,
          origem: produto.origem || '',
          categoria: produto.categoria ? produto.categoria : categoria.id || '',
          // ICMS
          picms: numOrNull(produto.pICMS),   // % ICMS
          predBc: numOrNull(produto.pRedBC), // se você extrair redução da base depois; por ora ficará null
          // IPI
          cstIpi: (produto.cstIPI ?? '').toString() || null,
          pipi: numOrNull(produto.pIPI),
          // PIS
          cstPis: (produto.cstPIS ?? '').toString() || null,
          ppis: numOrNull(produto.pPIS),
          // COFINS
          cstCofins: (produto.cstCOFINS ?? '').toString() || null,
          pcofins: numOrNull(produto.pCOFINS),

          ativo: true,
        };

        console.log(payload);
        const response = await axios.post(
          `https://techfood-api.herokuapp.com/v1/restaurantes/${loja.id}/produtos`,
          payload,
          options
        );

        console.log(response.data);
        if (response.data?.id) {
          produto.id = response.data.id;
          produto.ean = response.data.ean || 'SEM GTIN';
          produto.custo = produto.custo;
          produto.nomeSistema = produto.nome;

          // Atualiza encontradoVia para EAN se for válido
          if (produto.ean != 'SEM GTIN' && produto.ean != null && produto.ean != '') {
            produto.encontradoVia = 'EAN';
          } else {
            // 2. Fazer ligação com referencias-entrada para produtos ainda sem encontradoVia
            const payload = {
              idProdCprod: produto.cProd,
              idProd: produto.id,
              cnpjXml: produto.cnpj,
              idLoja: loja.id,
            };

            try {
              const resp = await axios.post(
                'https://techspdv-api-d3e739785e34.herokuapp.com/v1/referencias-entrada',
                payload,
                options
              );

              produto.encontradoVia = 'CPROD'; // atualiza após vínculo
            } catch (error) {
              console.error('Erro ao vincular produto via referencias-entrada:', produto.nome, error);
              setPodeAbandonar(true);
            }
          }

        }
      } catch (error) {
        console.error('Erro ao criar produto:', produto.nome, error);
        setPodeAbandonar(true);
      }
    }


    // Atualiza o array original pelos cProds
    const novosProdutos = atualizarProdutosPorCProd(produtos, produtosTratados);
    setProdutos(novosProdutos);

    console.log("✅ Produtos atualizados por cProd:", novosProdutos);



    setDesabilitarFinalizar(true);
    let valorComDesconto = 0;

    const novoObjeto = novosProdutos.reduce((acc, p) => {
      if (p.encontradoVia == 'EAN' || p.encontradoVia == 'CPROD') {
        acc.push({
          id: p.id,
          movimentacao: p.quantidade,
          valor: p.custo
        });
      }
      return acc;
    }, []);

    console.log("Novo objeto:", novoObjeto);
    console.log("produtos", produtos);

    let total = novosProdutos.reduce((soma, produto) => {
      return soma + parseFloat(produto.custo * produto.quantidade || 0);
    }, 0);

    let desconto = novosProdutos.reduce((desconto, produto) => {
      return desconto + parseFloat(produto.desconto || 0);
    }, 0);

    total = total - desconto;


    if (novoObjeto.length > 0) {
      setProcessamentoMsg('Iniciando movimentação de estoque...');
      try {
        const response = await axios.get(
          `https://techspdv-api-d3e739785e34.herokuapp.com/v1/movimentacaoEstoque/geraTransacao/${loja.id}`,
          options
        );
        setPodeAbandonar(true);
        console.log('Transação criada:', response.data);
        // continue com a lógica usando response.data (o id da transação)

        let cont = 0;
        let transactionInfo;
        do {
          setProcessamentoMsg('Enviando movimentação para o estoque...');
          axios.put(`https://techspdv-api-d3e739785e34.herokuapp.com/v1/movimentacaoEstoque/editarLista/${loja.id}/${response.data}/nfce/${total}/${cabecalho.chave}/${cabecalho.numero}/${cabecalho.serie}/${idUser}`, novoObjeto, options);

          if ((loja.id, response.data)) {
            transactionInfo = await axios.get(`https://techspdv-api-d3e739785e34.herokuapp.com/v1/movimentacaoEstoque/transacao/${response.data}`, options);



            if (transactionInfo.data.status !== '1') {
              console.log(transactionInfo.data);
              setTransactionId(response.data);
              setExecutarBusca(true);
              setProdutos([]);
              notification.info({
                message: 'Informação',
                description: 'As alterações estão sendo processadas.',
              });


              setCabecalho(null);

              setDestinatario(null);

            } else {
              await new Promise((resolve) => setTimeout(resolve, 10000));
              cont++;
              console.log(cont + 'tentativa');
              if (cont === 6) {
                setLoading(false);
                setProcessamentoMsg('');
                notification.error({
                  message: 'Erro',
                  description:
                    'Não foi possível o envio das alterações, tente novamente mais tarde.',
                });
              }
            }
          }
        } while (transactionInfo.data.status === '1' && cont < 6);
      } catch (error) {
        setPodeAbandonar(true);
        if (error.response && error.response.status === 409) {
          notification.info({
            message: 'Informação',
            description: 'Já existe uma transação ativa para essa loja nos últimos 30 segundos.',
          });
        } else {
          console.error('Erro ao criar transação:', error);
          // outros tipos de erro
        }
        setPodeAbandonar(true);
      }
    } else {
      setLoading(false);
      setDesabilitarFinalizar(false);
      setProcessamentoMsg('');
    }
    setLoading(false);
    setDesabilitarFinalizar(false);
    setProcessamentoMsg('');
    setPodeAbandonar(true);
  }

  return (
    <div style={{ padding: 16, boxSizing: 'border-box', maxWidth: '100%', overflowX: 'hidden', height: '80vh' }}>
      <Title level={4} style={{ marginBottom: 8 }}>Entrada por nota fiscal XML</Title>
      {
        isFinalizarEntrada ? (
          <CadastroProdutoModal
            produtos={produtosParaCriar}
            categorias={categorias}
            setCategorias={setCategorias}
            setProdutos={setProdutosParaCriar}
            setIsFinalizarEntrada={setIsFinalizarEntrada}
            salvarEntrada={salvarEntrada}
            onCriarCategoria={async (nome) => {
              console.log(nome);

              const resp = await axios.post(
                `https://techfood-api.herokuapp.com/v1/categorias/${loja.id}`,
                { nome },
                { headers: { Authorization: `Bearer ${accessToken}` } }
              );

              return resp.data;
            }}
          />
        ) :
          isModalVisibleItem ? (
            <RelacaoProdutos
              closeModal={handleVoltarClick}
              produto={selectedProduto}
              idLoja={loja.id}
              onSave={(updatedProduto) => {
                const novosProdutos = [...produtos];
                const index = produtos.findIndex(p =>
                  p.cProd === updatedProduto.cProd && p.nItem === updatedProduto.nItem
                );
                if (index !== -1) {
                  novosProdutos[index] = updatedProduto;
                  setProdutos(novosProdutos);
                }
              }}
            />) : (
            <>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                <div
                  style={{
                    flex: 1,
                    marginRight: '10px',
                    backgroundColor: '#000',
                    color: '#fff',
                    padding: '15px',
                    borderRadius: '5px',
                    border: 'none',
                    fontSize: '16px',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}>
                  <center> <Upload
                    disabled={loading}
                    beforeUpload={(file) => {
                      if (loading) {
                        message.warning("Aguarde, o processamento atual está em andamento.");
                        return Upload.LIST_IGNORE;
                      }
                      setLoading(true);
                      handleFileUpload(file);
                      return false;
                    }}

                    showUploadList={false}
                    style={{
                      flex: 1,
                      marginRight: '10px',
                      backgroundColor: '#000',
                      color: '#fff',
                      padding: '15px',
                      borderRadius: '5px',
                      border: 'none',
                      fontSize: '16px',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}

                    accept=".xml">
                    <button>
                      <span style={{ display: 'block', fontSize: '24px' }}><FontAwesomeIcon icon={faFileCode} /></span>
                      Arraste ou Selecione o XML aqui.
                    </button>
                  </Upload>
                  </center>
                </div>
                <button
                  disabled={desabilitarFinalizar || loading}
                  style={{
                    flex: 1,
                    backgroundColor: '#90ee90',
                    color: '#000',
                    padding: '15px',
                    borderRadius: '5px',
                    border: 'none',
                    fontSize: '16px',
                  }}
                  onClick={() => {
                    !produtos.length > 0 ? window.alert('Adicione produtos a entrada!') :
                      prepararEntrada();
                  }}

                >
                  <span style={{ display: 'block', fontSize: '24px' }}>✔️</span>
                  Finalizar Entrada
                </button>
              </div>

              {loading ? (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 40, width: '100%' }}>
                  <Spin
                    spinning={loading}
                    tip={<span style={{ fontSize: 16, fontWeight: '500', color: '#333' }}>Carregando...</span>}
                    size="large"
                  />
                  {processamentoMsg && (
                    <span style={{ marginTop: 16, fontSize: 14, color: '#666' }}>{processamentoMsg}</span>
                  )}
                </div>
              ) : null}
              {!loading && cabecalho && (
                <div style={{ marginTop: 16, fontSize: 12 }}>
                  <Row gutter={[12, 4]}>
                    <Col span={24}><Text><strong>Emitente:</strong> {cabecalho.nomeEmitente}</Text></Col>
                    <Col span={8}><Text><strong>Data NF:</strong> {cabecalho.data}</Text></Col>
                    <Col span={8}><Text><strong>CNPJ:</strong> {formatCNPJ(cabecalho.cnpj)}</Text></Col>
                    <Col span={8}><Text><strong>IE:</strong> {formatIE(cabecalho.ie)}</Text></Col>
                    <Col span={8}><Text><strong>Qtd. Itens:</strong> {cabecalho.qtdItens}</Text></Col>
                    <Col span={8}><Text><strong>Número NF:</strong> {cabecalho.numero}</Text></Col>
                    <Col span={8}><Text><strong>Valor Total:</strong> {cabecalho.total}</Text></Col>
                    <Col span={24}><Text><strong>Chave NF-e:</strong> {cabecalho.chave}</Text></Col>
                  </Row>
                  <Divider style={{ marginTop: 12, marginBottom: 12 }} />
                </div>
              )
              }

              {
                !loading && destinatario && (
                  <Card size="small" title="Destinatário" style={{ marginBottom: 12 }}>
                    <p style={{ fontSize: 12, marginBottom: 2 }}><strong>Nome:</strong> {destinatario?.nome}</p>
                    <p style={{ fontSize: 12, marginBottom: 2 }}><strong>CNPJ:</strong> {destinatario.cnpj ? formatCNPJ(destinatario.cnpj) : ''}</p>
                  </Card>
                )
              }

              {
                loading == false && produtosOrdenados.length > 0 && (
                  <div
                    style={{
                      height: '80vh',
                      overflowY: 'auto',
                      overflowX: 'hidden',
                      paddingRight: 8,
                    }}
                  >
                    <Row gutter={[8, 8]}>
                      {produtosOrdenados.map((item, index) => (
                        <Col span={24} key={index}>
                          <Card
                            title={<Row justify="space-between" align="middle">
                              <Col>
                                <span style={{ fontSize: 14, fontWeight: 'bold' }}>
                                  {item.cProd} - {item.nome}
                                </span>
                              </Col>

                              <Col style={{ display: 'flex', gap: 10 }}>
                                <span
                                  style={{
                                    fontSize: 14,
                                    fontWeight: 'bold',
                                    color: item.encontradoVia ? '#155724' : '#721c24', // verde escuro ou vermelho escuro
                                    backgroundColor: item.encontradoVia ? '#d4edda' : '#f8d7da', // verde claro ou vermelho claro
                                    padding: '4px 8px',
                                    borderRadius: '12px',
                                    display: 'inline-block',
                                    minWidth: '80px',
                                    textAlign: 'center',
                                  }}
                                >
                                  {item.encontradoVia ? item.encontradoVia : 'NÃO ENCONTRADO'}
                                </span>
                                {item.encontradoVia != 'EAN' ?
                                  <button
                                    style={{
                                      fontSize: 15,
                                      padding: '4px 10px',
                                      cursor: 'pointer',
                                      borderRadius: 4,
                                      border: 'none',
                                      backgroundColor: 'black',
                                      color: 'white',
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: 4
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      if (!item.travado) openModalItem(item);
                                    }}
                                  >
                                    <FontAwesomeIcon icon={faLink} />
                                  </button> : <span
                                    style={{
                                      padding: '4px 10px',
                                      backgroundColor: 'white',
                                      display: 'flex',
                                      gap: 4,
                                      visibility: 'hidden'
                                    }}
                                  >
                                    <FontAwesomeIcon icon={faLink} />
                                  </span>
                                }

                              </Col>
                            </Row>}
                            bordered={true}
                            style={{ width: '100%' }}
                            bodyStyle={{ padding: 8 }}
                            size="small"
                          >
                            <Row gutter={[12, 4]} style={{ fontSize: 12 }}>
                              <Col><strong>QTD:</strong> {parseFloat(item.quantidade || 0).toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 5 })
                              }</Col>
                              <Col><strong>V.UNITÁRIO:</strong> {formatCurrency(item.preco)}</Col>
                              {item.vDesc != 0 ? <Col><strong>V.C.DESC:</strong> {formatCurrency(item.custo)}</Col> : null}
                            </Row>
                            <Row gutter={[12, 4]} style={{ fontSize: 12, marginBottom: 4 }}>
                              <Col><strong>EAN:</strong> {item.ean}</Col>
                              <Col><strong>NCM:</strong> {item.ncm}</Col>
                              <Col><strong>{item.csosn ? 'CSOSN' : 'CST'}:</strong> {item.origem}{item.csosn || item.cst}</Col>
                              <Col><strong>CFOP:</strong> {item.cfop}</Col>
                              <Col><strong>UN:</strong> {item.uCom}</Col>
                              <Col><strong>V.TOTAL:</strong> {formatCurrency(item.vProd)}</Col>
                              <Col><strong>BC ICMS:</strong> {formatCurrency(item.vBC)}</Col>
                              <Col><strong>V.ICMS:</strong> {formatCurrency(item.vICMS)}</Col>
                              <Col><strong>V.IPI:</strong> {formatCurrency(item.vIPI)}</Col>
                              <Col><strong>ALIQ.ICMS:</strong> {formatCurrency(item.pICMS)}</Col>
                              <Col><strong>ALIQ.IPI:</strong> {formatCurrency(item.pIPI)}</Col>
                              {item.vDesc != 0 ? <Col><strong>V.DESC:</strong> {formatCurrency(item.vDesc)}</Col> : null}

                            </Row>


                          </Card>
                        </Col>
                      ))}
                    </Row>
                  </div>
                )
              }
            </>)}
    </div>
  );
};

export default XmlToJsonConverter;
